import { initConfetti } from 'js/lib/confetti.js'

export function initConfettiComponent() {
  const el = document.querySelector('#js-c-confetti')
  if (!el) return

  const duration = parseInt(el.dataset.duration, 10) || 2000
  const triggerType = el.dataset.triggerType || 'manual'
  const delay = parseInt(el.dataset.delay, 10) || 0

  const fireConfetti = () => {
    initConfetti(duration)
    el.dataset.trigger = 'false'
  }

  switch (triggerType) {
    case 'onload':
      window.addEventListener('DOMContentLoaded', () => fireConfetti())
      break

    case 'delay':
      setTimeout(fireConfetti, delay)
      break

    case 'inview':
      // eslint-disable-next-line no-undef
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            fireConfetti()
            observer.disconnect()
          }
        })
      })
      observer.observe(el)
      break

    case 'manual':
    default:
      // eslint-disable-next-line no-undef
      const observerManual = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'data-trigger' &&
            el.dataset.trigger === 'true'
          ) {
            fireConfetti()
          }
        }
      })
      observerManual.observe(el, { attributes: true })
      break
  }
}

document.addEventListener('DOMContentLoaded', initConfettiComponent)
